<script setup lang="ts">
import type { LocationQuery } from "vue-router"

definePageMeta({
  name: "search-offline",
  title: "Søk (Offline)",
  layout: "navigation",
})

const route = useRoute<"search-offline">()
const returnTo = ref(firstString(route.query.from) || "/exphil")
function firstString(value: LocationQuery[string] | undefined) {
  return (Array.isArray(value) ? value[0] : value) ?? ""
}
</script>

<template>
  <div class="grid grid-cols-3">
    <div class="col-span-1">
      <div>
        <NuxtLink
          v-wave
          :to="returnTo"
          class="grid rounded-full border-2 border-current p-4 hover:border-u-contrast md:fixed md:left-5 md:top-5"
          aria-label="Lukk søk"
        >
          <UIcon
            name="close"
            class="stroke-current"
            size="xxs"
          />
        </NuxtLink>
      </div>

      <div>
        <USearchBar />
        <p class="mt-5 font-national2 font-bold italic">
          0 treff
        </p>
        <hr class="my-2 border" />
      </div>
      <UOfflineMessage />
    </div>
  </div>
</template>
